import { ReactNode, useEffect, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './AuthProvider';

const Loading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);

export function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const auth = useAuth();
  const startedLoginRef = useRef(false);

  // Login is a side-effect; never invoke it during render. Under
  // React.StrictMode, render runs twice in dev and would otherwise kick
  // off two OIDC redirects.
  useEffect(() => {
    if (!auth.isPending && !auth.isAuthenticated && !startedLoginRef.current) {
      startedLoginRef.current = true;
      try {
        auth.login();
      } catch (err) {
        console.error('[ProtectedRoute] auth.login() threw:', err);
      }
    }
  }, [auth]);

  if (auth.isPending || !auth.isAuthenticated) {
    return <Loading />;
  }

  return <>{children}</>;
}
